class Auth {
    static getLoggedUser() {
        let loggedUser = localStorage.getItem('logged_user')
        if (loggedUser === "" || loggedUser === 'undefined') {
            loggedUser = null
        } else {
            loggedUser = JSON.parse(loggedUser)
        }
        return loggedUser;
    }

    static setLoggedUser(loggedUser) {
        localStorage.setItem('logged_user', JSON.stringify(loggedUser));
    }

    static deleteLoggedUser() {
        localStorage.removeItem('logged_user');
    }

    static canUserDo(actions, loggedUser) {
        if (loggedUser === null) {
            return false;
        }
        for (let i in actions) {
            if (loggedUser.actionsEnabled.indexOf(actions[i]) === -1) {
                return false;
            }
        }
        return true;
    }
}

export default Auth